export default __webpack_public_path__ + "static/media/apvs-material-1.eda823ce.webp";